<template>
  <FriedTableRow class="loading-row">
    <FriedTableCell colspan="8" class="loader-cell">
      <FriedSpinner class="row-loader" />
    </FriedTableCell>
  </FriedTableRow>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoaderRow',
});
</script>

<style lang="scss" scoped>
.loading-row {
  height: 5rem;

  .loader-cell {
    justify-content: center;
  }

  .row-loader {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
